import { Modal } from '../../components/Modal';

export class MobileSort extends Modal {
  constructor(args) {
    super(args.dialog, args.context);
    this.form = args.form;

    // Bind methods
    this.init();
  }

  init() {
    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      this.#handleSubmit();
    });

    this.form.querySelectorAll('input, select, textarea').forEach((input, idx) => {
      if (idx === 0) {
        input.checked = true;
      }
      input.addEventListener('change', this.#handleChange.bind(this));
    });
  }

  /**
   * Registers a callback function to be called when a sort option changes.
   * @param {Function} callback - a custom function
   */
  onSortChange(callback) {
    this.sortChangeCallback = callback;
  }

  #handleChange(e) {
    // Handle input change logic here
    if (e.target.checked) this.sortChangeCallback(e);
  }

  #handleSubmit() {
    // Handle form submission logic here
    return;
  }
}
